import PropTypes from 'prop-types';
import { Button, Row } from 'antd';
import { useListNodes } from './hooks/useListNodes';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { debounceFunction } from '../../../../utility/utility';

export function ButtonLoadMoreItems({ path, nodeId, page = 1, pageSize = 0, total = 0 }) {
  const listNodesData = useListNodes();
  const { translate: t } = useDictionaryTranslation();
  const loadMore = debounceFunction(() => {
    listNodesData.getListNodesPaginated({
      nodeId,
      path,
      page: page + 1,
    });
  }, 250);

  return pageSize * page < total ? (
    <Row justify="center" style={{ marginBottom: 20 }}>
      <Button block type="primary" onClick={loadMore}>
        {t('viewMore')}
      </Button>
    </Row>
  ) : null;
}

ButtonLoadMoreItems.propTypes = {
  path: PropTypes.array,
  nodeId: PropTypes.string,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
};
